module.exports = __webpack_public_path__ + "img/caldero.f03439e3.gif";